export { runtimeInit } from "./runtimeInit";

// Component decorators
export {
  // Class decorators
  component,
  displayName,
  icon,
  color,
  category,
  requireComponent,
  executeInEditor,
  allowMultiple,
  customEditor,
  // Field decorator
  field,
  // Runtime-only-state marker
  runtime,
  // Utilities
  getComponentMetadata,
  getFieldMetadata,
  getFieldDefs,
  getCustomEditorName,
  fieldMetadataToFieldDef,
  getAllComponents,
  getComponentByTypeId,
  componentRegistry,
  COMPONENT_METADATA,
  // Types
  type FieldOptions,
  type FieldMetadata,
  type ComponentMetadata,
} from "./component";
